import Add from 'assets/Icons/AddIcons/Add';
import { pagePaths } from './path';
import LnbHospitalHomeIcon from 'assets/Icons/SideBarList/LnbHospitalHomeIcon';
import LnbDiagnosisTodayIcon from 'assets/Icons/SideBarList/LnbDiagnosisTodayIcon';
import LnbDiagnosisListIcon from 'assets/Icons/SideBarList/LnbDiagnosisListIcon';
import LnbPatientListOutlineIcon from 'assets/Icons/SideBarList/LnbPatientListIcon';
import LnbSettingHospitalIcon from 'assets/Icons/SideBarList/LnbSettingHospitalIcon';
import LnbAdminCalculateIcon from 'assets/Icons/SideBarList/LnbAdminCalculateIcon';
import LnbAdminApprovalIcon from 'assets/Icons/SideBarList/LnbAdminApprovalIcon';
import LnbAdminHospitalIcon from 'assets/Icons/SideBarList/LnbAdminHospitalIcon';
import IcLnbApproval from 'assets/Icons/SideBarList/IcLnbApproval';
import IcLnbReady from 'assets/Icons/SideBarList/IcLnbReady';
import DckIcon from 'assets/Icons/SideBarList/DckIcon';
import ClIcon from 'assets/Icons/SideBarList/ClIcon.png';
import SettingGnbIcon from 'assets/Icons/SideBarList/SettingGnbIcon';

export const HospitalSideBarConstants = (currentPath: string) => {
    return [
        { icon: <Add />, name: '진료 추가', path: pagePaths.addDiagnosis },
        { icon: <LnbHospitalHomeIcon $active={currentPath === pagePaths.dckHome} />, name: '우리병원 홈', path: pagePaths.dckHome },
        { icon: <LnbDiagnosisTodayIcon $active={currentPath === pagePaths.todayDiagnosis} />, name: '오늘의 진료', path: pagePaths.todayDiagnosis },
        { icon: <LnbDiagnosisListIcon $active={currentPath === pagePaths.diagnosisList} />, name: '진료 목록', path: pagePaths.diagnosisList },
        { icon: <LnbPatientListOutlineIcon $active={currentPath === pagePaths.managingPatients} />, name: '등록 환자 관리', path: pagePaths.managingPatients },
        { icon: <LnbSettingHospitalIcon $active={currentPath === pagePaths.hospitalSetting} />, name: '병원 설정', path: pagePaths.hospitalSetting },
    ];
};

export const HospitalAdminSideBarConstants = (currentPath: string) => {
    return [
        { icon: <LnbDiagnosisListIcon $active={currentPath === pagePaths.adminDiagnosisList} />, name: '진료 목록', path: pagePaths.adminDiagnosisList },
        { icon: <LnbAdminHospitalIcon $active={currentPath === pagePaths.adminManageHospital} />, name: '등록 병원 관리', path: pagePaths.adminManageHospital },
        { icon: <LnbAdminApprovalIcon $active={currentPath === pagePaths.adminManageUserJoin} />, name: '가입 요청 관리', path: pagePaths.adminManageUserJoin },
        { icon: <LnbAdminCalculateIcon $active={currentPath === pagePaths.calculate} />, name: '병원 검사 정산', path: pagePaths.calculate },
        { icon: <LnbAdminCalculateIcon $active={currentPath === pagePaths.assessmentPayment} />, name: '개별 검사 정산', path: pagePaths.assessmentPayment },
        { isDivider: true },
        { icon: <LnbAdminCalculateIcon $active={currentPath === pagePaths.adminVoucherList} />, name: '바우처 코드 관리', path: pagePaths.adminVoucherList },
        { icon: <LnbAdminCalculateIcon $active={currentPath === pagePaths.adminCounselerList} />, name: '상담사 관리', path: pagePaths.adminCounselerList },
        // { icon: <SettingHospital $active={currentPath === pagePaths.hospitalSetting} />, name: '병원 설정', path: pagePaths.hospitalSetting },
    ];
};
export const CLAdminSideBarConstants = (currentPath: string, isAdminAccount = true) => {
    const sideBarItems = [
        { icon: <LnbPatientListOutlineIcon $active={currentPath.includes('managing-patients')} />, name: '사용자 관리', path: pagePaths.CLAdminManagePatient },
    ];

    if (isAdminAccount) {
        sideBarItems.push({ icon: <LnbPatientListOutlineIcon $active={currentPath.includes('/admin/cl/users')} />, name: '사용자 조회', path: pagePaths.CLAdminUserLookup });
    }

    return sideBarItems;
};

export const SettingsSideBarConstants = (currentPath: string) => {
    return [
        { icon: <LnbAdminApprovalIcon $active={currentPath === pagePaths.SettingsAdminUserRole} />, name: '관리자 조회', path: pagePaths.SettingsAdminUserRole },
    ];
};

export const ExCounselSideBarConstants = (currentPath: string) => {
    return [
        { icon: <LnbDiagnosisTodayIcon $active={currentPath === pagePaths.mindUpAdminTodayDiagnosis} />, name: '오늘 나의 상담', path: pagePaths.mindUpAdminTodayDiagnosis },
        { icon: <IcLnbApproval $active={currentPath === pagePaths.mindUpAdminUserReservationConsultation} />, name: '예약된 나의 상담', path: pagePaths.mindUpAdminUserReservationConsultation },
        { icon: <IcLnbReady $active={currentPath === pagePaths.mindUpAdminAllReservationConsultation} />, name: '예약 대기 상담', path: pagePaths.mindUpAdminAllReservationConsultation },
        { icon: <LnbDiagnosisListIcon $active={currentPath === pagePaths.mindUpAdminDiagnosisList} />, name: '상담 목록', path: pagePaths.mindUpAdminDiagnosisList },
    ];
};
export const sideBarConstants = [
    { name: '닥터스상담', icon: <DckIcon />, service: 'DOCTORS_COUNSELING' },
    // TODO. 기존 패턴으로 수정 필요 (svg)
    { name: '칼로리랩', icon: <img src={ClIcon} alt="ClIcon" width={24} height={24} />, service: 'CALORIE_LAB' },
    { name: '설정', icon: <SettingGnbIcon />, service: 'SETTINGS' },
];

const SERVICE_TO_GNB_SERVICE = {
    DCK: 'DOCTORS_COUNSELING',
    CL: 'CALORIE_LAB',
} as const;

export const getVisibleSideBarConstants = (hospitalServices?: string[], accountLevel?: number) => {
    if (accountLevel === 100) {
        return sideBarConstants;
    }

    const selectedServices = hospitalServices?.length ? hospitalServices : ['DCK'];
    const visibleGnbServices = selectedServices.map((service) => SERVICE_TO_GNB_SERVICE[service as keyof typeof SERVICE_TO_GNB_SERVICE]).filter(Boolean);

    return sideBarConstants.filter((list) => visibleGnbServices.includes(list.service as (typeof visibleGnbServices)[number]));
};
